import { createApp } from 'vue'
import App from './App.vue'

import {createRouter, createWebHistory} from 'vue-router'

import Main from "@/routes/Main"
import Table from "@/routes/Table"
import Quiz from "@/routes/Quiz"
import Tree from "@/routes/Tree"
import Algo from "@/routes/Algo"

const routes = [
    { path: "/", name: "main", component: Main},
    { path: "/quiz", name: "quiz", component: Quiz},
    { path: "/table", name: "table", component: Table},
    { path: "/tree", name: "tree", component: Tree},
    { path: "/algo", name: "random", component: Algo},
    { path: "/algo/:algoId", name: "algo", component: Algo, props: true},
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

const app = createApp(App)
app.use(router)
app.mount("#app")
